//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../axios/axios.js'
import UpdatesManager from '../../components/UpdatesManager.js'

export default {
  props: {
    errorId: {
      type: Number,
      default: null
    }
  },
  data: function () {
    return {
      timerPart1: '',
      timerPart2: '',
      timerPart3: '',
      startDate: new Date(),
      publicPath: process.env.BASE_URL,
      updatesManager: new UpdatesManager({
        autoUpdate: true,
        autoUpdateTimeout: 10000,
        updateFn: () => {
          this.ping()
        },
        listenDocumentVisibility: true
      })
    }
  },
  created: function () {
    this.startTimer()
    if (this.errorId === 503) {
      this.updatesManager.onUpdate()
    }
  },
  beforeDestroy: function () {
    this.updatesManager.destroy()
  },
  methods: {
    ping: function () {
      return axiosGet({
        url: '/service/server/ping',
        onSuccess: (response) => {
          console.log('Соеденинение с сервером восстановлено')
          if (window.history.length != 1 && window.history.state !== null) {
            this.$router.back()
          } else {
            this.$router.push('/')
          }
          return response
        },
        onFailure: () => {
          return Promise.reject(Error('Соединение с сервером потеряно!'))
        }
      })
    },
    startTimer () {
      const that = this
      this.startClockId = setTimeout(function run () {
        let diff = (new Date()) - that.startDate
        let seconds = 0
        let minutes = 0
        diff = (diff - (diff % 1000)) / 1000
        diff = (diff - (seconds = diff % 60)) / 60
        diff = (diff - (minutes = diff % 60)) / 60
        that.timerPart1 = ('0' + diff % 24).slice(-2)
        // Math.floor(now / (1000 * 60 * 60))
        that.timerPart2 = ('0' + minutes).slice(-2)
        // Math.floor(now / (1000 * 60))
        that.timerPart3 = ('0' + seconds).slice(-2)
        // Math.floor(now / (1000))
        if (!that.startClockId) {
          clearTimeout(this.startClockId)
          this.startClockId = null
        }
        setTimeout(run, 1000)
      }, 1)
    }
  }
}
